
    import { Component, Vue, Prop } from 'nuxt-property-decorator';
    import Button from '@/components/blocks/Button.vue';
    import ImageComponent from '@/components/blocks/ImageComponent.vue';
    import Form from '@/components/blocks/Form.vue';
    import OptionsFieldsInlineEditor from '@/components/editor/options/fields/OptionsFieldsInlineEditor.vue';
    import { AvailableGroups, AvailableTypes } from '@/components/editor/config/types';
    import BlogComponentWrapper from '@/components/blocks/blog/BlogComponentWrapper.vue';

    export const meta = {
        title: 'Простая форма',
        options: {
            head: {
                type: AvailableTypes.editor,
                title: 'Заголовок',
                default: 'Что ещё сделать?'
            },
            text: {
                type: AvailableTypes.editor,
                title: 'Текст',
                default:
                    'Приехать на фабрику, посмотреть образцы, подобрать материалы, проконсультироваться с технологом'
            },
            form: {
                type: AvailableTypes.component,
                componentName: 'Form'
            },
            additionalComponent: {
                type: AvailableTypes.additionalComponent
            }
        },
        group: AvailableGroups.Блог
    };

    @Component({
        components: {
            OptionsFieldsInlineEditor,
            Form,
            ImageComponent,
            BlogComponentWrapper,
            Button
        }
    })
    export default class SimpleForm extends Vue {
        @Prop() component;
        @Prop() head;
        @Prop() form;
        @Prop() additionalComponent;
    }
